import { DataField } from './DataFieldBase';

export class DataFieldDropdown extends DataField<string> {
  controlType = 'dropdown';
  options: {key: string, value: string}[] = [];

  constructor(options: {} = {}) {
    super(options);
    this.options = options['options'] || [];
  }
}